import * as React from 'react';
import { ImageField, ImageInput } from 'react-admin';
import { useForm } from 'react-final-form';
import { apiUrl, httpClient } from '../providers/data.provider';

const PreviewImage = ({ record, source }: any) => {
	if (typeof (record) == 'string') {
		record = {
			[source]: record
		};
	}
	return <ImageField record={record} source={source}/>;
};

export const UploadImage = ({ record, source, ...props }: any) => {
	const form = useForm();

	const onFileChange = async (fileToUpload: any) => {
		if (fileToUpload) {
			const formData = new FormData();

			formData.append('fileToUpload', fileToUpload);

			const { json } = await httpClient(`${apiUrl}/files/upload`, {
				method: 'POST',

				body: formData
			});

			form.change(source, json.data);
		}
	};

	return <ImageInput {...props} source={source}
	                   onChange={onFileChange}
	>
		<PreviewImage source="src"/>
	</ImageInput>;
};
